module.exports = __webpack_public_path__ + "static/img/load.15865ebb.jpeg";